// @ts-nocheck
import { crmFilesAPI } from '@greenkub-fronts/data-access';
import { addErrorMessage } from '@greenkub-fronts/domain/snackbar';
import { GROUP_NAME } from '@greenkub-fronts/shared/interface';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const initSignaturePageUseCase = createAsyncThunk(
  'initSignaturePageUseCase',
  async (
    data: {
      isSignature: boolean;
      fromExisting: boolean;
      toGenerate: boolean;
      projectToken: string | undefined;
      projectId: string | undefined;
      documentId: string | undefined;
      documentSlug: string | undefined;
      upsellId: string | undefined;
      upsellToken: string | undefined;
    },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    let projectQuery = null;
    let upsellQuery = null;
    let tokenIsValid = false;
    let documentQuery = null;
    let documentObjectURL: null | string = null;
    let documentIsLoaded = false;

    /**
     * Si page de signature
     */
    if (data.isSignature) {
      projectQuery = await dispatch(
        extra.apiSlice.endpoints.getProjectByToken.initiate({
          token: data.projectToken,
          groupName: GROUP_NAME.PROJECT_FOR_PAGE_SIGNATURE,
        })
      );
      tokenIsValid = true;

      if (data.upsellToken) {
        upsellQuery = await dispatch(
          extra.apiSlice.endpoints.getUpsellByToken.initiate({
            token: data.upsellToken,
          })
        );
        if (upsellQuery.error) {
          dispatch(addErrorMessage(upsellQuery.error));
        }
      }
    }

    /**
     * Si page de prévisualisation de signature
     */
    if (!data.isSignature && data.projectId) {
      projectQuery = await dispatch(
        extra.apiSlice.endpoints.getProjectById.initiate({
          projectId: parseInt(data.projectId),
          groupName: GROUP_NAME.PROJECT_FOR_PAGE_SIGNATURE,
        })
      );

      if (data.upsellId) {
        upsellQuery = await dispatch(
          extra.apiSlice.endpoints.getUpsellById.initiate({
            upsellId: parseInt(data.upsellId),
          })
        );
        if (upsellQuery.error) {
          dispatch(addErrorMessage(upsellQuery.error));
        }
      }
    }

    if (data.fromExisting && data.documentId) {
      documentQuery = await dispatch(
        extra.apiSlice.endpoints.getDocumentById.initiate({
          documentId: parseInt(data.documentId),
        })
      );

      await crmFilesAPI
        .getDocumentBlobById(documentQuery.data.id)
        .then((resp) => {
          documentObjectURL = URL.createObjectURL(resp.data);
          documentIsLoaded = true;
        });
    }

    return {
      toGenerate: data.toGenerate,
      fromExisting: data.fromExisting,
      isSignature: data.isSignature,
      project: projectQuery?.data,
      projectId: parseInt(data.projectId),
      upsell: upsellQuery?.data,
      tokenIsValid: tokenIsValid,
      signature:
        projectQuery?.data.customer.lastName +
        ' ' +
        projectQuery?.data.customer.firstName,
      document: documentQuery?.data,
      documentIsLoaded: documentIsLoaded,
      documentObjectURL: documentObjectURL,
      projectToken: data.projectToken,
      upsellToken: data.upsellToken,
      documentSlug: data.documentSlug,
      upsellId: data.upsellId,
    };
  }
);

export default initSignaturePageUseCase;
